import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Rist Management section for eligibility tab
 */
const RiskManagementSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="risk-management-section-component"
    >
      <AccordionV2
        testId="risk-management"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Risk Management" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>
            The following criteria are used to identify the final shortlist of
            companies:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Risk strategy and appetite which is well articulated, formalised
              and integrated into the enterprise-wide decision making process at
              all levels;
            </li>

            <li>
              Formalised risk governance structure with clear roles and
              responsibilities across the various lines of defense;
            </li>

            <li>
              The extent to which the organisation&apos;s risk culture permeates
              across all levels of management and staff;
            </li>

            <li>
              A clearly defined and effective risk identification, assessment,
              and measurement process which aligns the organisations strategy;
            </li>

            <li>
              Adequate and effective risk management and internal control
              systems;
            </li>

            <li>
              Risk reporting and insights are timely and transparent to support
              internal and external stakeholder needs;
            </li>

            <li>
              The extent to which technology is used to enhance data quality,
              governance and risk analytics;
            </li>
          </ul>

          <p>
            In addition, the extent to which companies disclose information in
            relation to:
          </p>

          <ul className="list-outside list-disc pl-8">
            <li>Innovation and Technology Governance;</li>

            <li>Sustainability Governance;</li>

            <li>Continuous Improvement of Enterprise Risk Management;</li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default RiskManagementSection;
